export default __webpack_public_path__ + "static/media/login_bg.7900c8be.png";